import { handleError } from './errorHandler';
import { IScheduleResponse, IScheduleLists, ISchedule } from './../../entities/schedule';
import fetcher from '../fetcher';
import { IDTO } from 'src/entities/common';
import isAfter from 'date-fns/isAfter';
import { IPaymentReservationDetails } from 'src/entities/paymentReservation';

const filterPast = (scheduleLists: IScheduleLists): IScheduleLists =>
    Object.fromEntries(Object.entries(scheduleLists)
        .map(([date, list]) => [date,
            list.filter(schedule =>
                isAfter(new Date(schedule.Start), new Date())
            )]
        )
        .filter(([list]) =>
            list.length > 0
        )
    );

export const getScheduleList = async (calendarId: number, startDate: string, endDate: string, includePast?: true): Promise<IScheduleLists> => {
    const params =
        new URLSearchParams({
            StartDate: startDate,
            EndDate: endDate
        }).toString();

    return fetcher.get<IDTO<IScheduleResponse>>(`/${calendarId}/Schedules?${params}`)
        .then(respJson => respJson.Data.Schedules)
        .then(includePast ? data => data : filterPast)
        .catch(e => { throw handleError(e) });
};

export const getScheduleById = async (paymentReservation: IPaymentReservationDetails): Promise<ISchedule | undefined> => {
    
    const { CalendarId, ScheduleId, StartTime, EndTime } = paymentReservation;

    if (!CalendarId) {
        return;
    }

    return getScheduleList(CalendarId, StartTime, EndTime, true)
        .then<ISchedule[][]>(Object.values)
        .then(schedules =>
            schedules.flat().find(sch => sch.Id === ScheduleId)
        )
        .catch(e => { throw handleError(e) });
};